import { render, staticRenderFns } from "./AppImplementTable.vue?vue&type=template&id=2f68cae9&scoped=true&"
import script from "./AppImplementTable.vue?vue&type=script&lang=js&"
export * from "./AppImplementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f68cae9",
  null
  
)

export default component.exports